<template>
    <div>

        <projects-filter
                ref="filter"
                :selected="selected"
                v-on:fetchProjects="fetchOnFilter">

        </projects-filter>

        <transition name="fade" mode="out-in">
            <lfn-loader :loading-state="loadingState"></lfn-loader>
        </transition>

        <p class="container text-center" v-show="hasNoProjects">
            Er zijn helaas geen projecten bij deze categorie gevonden.
        </p>

        <projects-list
                :projects="projects">

        </projects-list>

        <div
                @click="paginate"
                v-html="paginator">

        </div>

    </div>
</template>
<script>
import ProjectsList from './projects-list';
import ProjectsFilter from './projects-filter';
import Loader from 'site/js/components/autoload/loader';

let baseFetchUrl = '/api/get-projects/';

export default{
    components: {
        'projects-list': ProjectsList,
        'projects-filter': ProjectsFilter,
        'lfn-loader': Loader
    },
    props:{
      'projectCollection': {required: true},
      'paginatorData': {required: false},
    },
    created: function(){
        window.addEventListener(
            'popstate', this.getProjectsOnPopstate
        )
    },
    data: function(){
        return {
            loadingState: false,
            projects: '',
            paginator: '',
            selected: this.getSelectedDropdownType()
        }
    },
    mounted: function(){
        this.projects = this.projectCollection;
        this.paginator = this.paginatorData;
    },
    methods: {

        /**
         * Return the lastslug. This one can contain the current project filter. This one can be used to set the dropdown
         * to the right chosen type on load.
         * @returns {string}
         */
        getSelectedDropdownType: function(){
            let lastSlug = window.location.href.substr(window.location.href.lastIndexOf('/') + 1);
            return lastSlug.split("?")[0];
        },

        /**
         * This function gets called on pop state. The popstate event is fired when the active history entry changes.
         * We can get the state of the event. This contains the data we passed when we set the pushstate of the history api.
         * In this case we have sent the url we need to fetch new items so we can fetch them after this.
         * @param e
         */
        getProjectsOnPopstate: function(e){
            let url = baseFetchUrl + e.state;
            this.fetchProjects(url);
        },

        /**
         * prevent the default action of the a tag and setup fetching the data with an ajax call. the link is the standard
         * link of the paginator object and will be used as fetch url. The history url is the last part of the url out
         * of the paginator object.
         * @param e
         */
        paginate: function(e){
            e.preventDefault();
            let fetchUrl = e.srcElement.href;

            if(!fetchUrl)
                return;

            let historyUrl = fetchUrl.substr(fetchUrl.lastIndexOf('/') + 1);

            this.setUrlAndFetchProjects(historyUrl, fetchUrl);
        },

        /**
         * Get the last slug to know what changes have to be made to the pushState function
         * */
        getLastIndexOfSlug: function(){
            return window.location.href.substr(window.location.href.lastIndexOf('/') + 1);
        },

        /**
         * The the right history Url. Check of the slug includes projecten and the history url does not include projecten
         * Then push projecten and the history url. otherwise just push the history url.
         * */
        setHistoryUrl: function(historyUrl){
            if(this.getLastIndexOfSlug().includes('projecten') && !historyUrl.includes('projecten')) {
                historyUrl = 'projecten/' + historyUrl;
            }
            history.pushState(historyUrl, null, historyUrl);
        },

        /**
         * Execute the functions which are used to change the state and content of the page.
         *
         * */
        setUrlAndFetchProjects: function(historyUrl, fetchUrl){
            this.setHistoryUrl(historyUrl);
            this.fetchProjects(fetchUrl);
        },

        /**
         * Setup the data for the filtering when we use the dropdown will be used.
         * @param filteredValue
         */
        fetchOnFilter: function(filteredValue){
            let fetchUrl = baseFetchUrl + filteredValue;
            this.setUrlAndFetchProjects(filteredValue, fetchUrl)
        },

        /**
         * Fetch the projects
         * @param url
         */
        fetchProjects: function(url){
            let _this = this;
            this.loadingState = true;

            axios.get(url)
                .then(function (response) {
                    _this.projects = response.data.projects;
                    _this.paginator = response.data.paginator;
                    _this.loadingState = false;
                })
        },
    },
    computed: {
        hasNoProjects: function(){
            return this.projects.length < 1;
        }
    }
}
</script>
<style lang="scss">
    .pagination{
        text-align: center;
        list-style: none;
        li {
            display: inline-block;
            width: auto;
            margin-right: 10px;
            &.active {
                color: #ffc107;
                font-weight: 600;
            }
            &.page-item a {
                color: #000;
            }
        }
    }

</style>